export default "__VITE_ASSET__DlYnGebS__";